import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  id: "sidenav-collapse-main",
  class: "collapse navbar-collapse w-auto h-auto h-100"
};
const _hoisted_2 = {
  class: "navbar-nav"
};
const _hoisted_3 = {
  class: "nav ms-4"
};
import SidenavItem from './SidenavItem.vue';
import SidenavCollapse from './SidenavCollapse.vue';
import SidenavCollapseItem from './SidenavCollapseItem.vue';
import ConstCode from '@/common/constants/ConstCode';
import { useRoute } from 'vue-router';
import { computed } from 'vue';
import { useInquiryStore } from '@/store/modules/inquiry/inquiry';
export default {
  __name: 'sidenavList',
  setup(__props) {
    const {
      NAVIGATION_ITEM
    } = ConstCode;
    const route = useRoute();
    const inquiryStore = useInquiryStore();
    const adminRead = computed(() => inquiryStore.adminReadStatus);
    const checkStatus = title => {
      if (title === '1:1 문의') return adminRead.value;
      return true;
    };
    const navigation = computed(() => NAVIGATION_ITEM);
    const getRoute = () => {
      return true;
    };
    const coloring = color => {
      if (!color) return 'black';
      return color;
    };
    return (_ctx, _cache) => {
      const _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("ul", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navigation.value, nav => {
        return _openBlock(), _createElementBlock("li", {
          key: nav.title,
          class: "nav-item"
        }, [_createVNode(SidenavCollapse, {
          "collapse-ref": `${nav.title}_ref`,
          "nav-text": nav.title
        }, {
          icon: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
            icon: nav.icon.name,
            size: nav.icon.size ?? 'lg',
            style: _normalizeStyle({
              color: nav.icon.color ?? 'black'
            })
          }, null, 8, ["icon", "size", "style"])]),
          list: _withCtx(() => [_createElementVNode("ul", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nav.inner, innerItem => {
            return _openBlock(), _createElementBlock(_Fragment, {
              key: `${nav.title}_${innerItem.title}`
            }, [!!innerItem?.inner ? (_openBlock(), _createBlock(SidenavCollapseItem, {
              key: 0,
              "admin-read": checkStatus(innerItem.title),
              refer: `${innerItem.title}_ref`,
              text: innerItem.title,
              "mini-icon": ""
            }, {
              "nav-child-item": _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(innerItem.inner, deepItem => {
                return _openBlock(), _createBlock(SidenavItem, {
                  key: `${nav.title}_${innerItem.title}_${deepItem.title}`,
                  text: deepItem.title,
                  to: deepItem.to,
                  "mini-icon": ""
                }, null, 8, ["text", "to"]);
              }), 128))]),
              _: 2
            }, 1032, ["admin-read", "refer", "text"])) : _createCommentVNode("", true), !innerItem?.inner ? (_openBlock(), _createBlock(SidenavItem, {
              key: 1,
              "admin-read": checkStatus(innerItem.title),
              text: innerItem.title,
              to: innerItem.to,
              "mini-icon": ""
            }, null, 8, ["admin-read", "text", "to"])) : _createCommentVNode("", true)], 64);
          }), 128))])]),
          _: 2
        }, 1032, ["collapse-ref", "nav-text"])]);
      }), 128))])]);
    };
  }
};